import { DataApiInputParams } from 'src/types/api';
import { Builder, getHeaders, getQueryString } from './utils';

const googleDriveApi = (builder: Builder) => {
  return {
    getGoogleDriveContent: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `providers/google_drive_provider?${getQueryString(
          arg.params.params
        )}`;
        const result: any = await fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });

        if (result.error) return result;

        return {
          data: {
            files: result.data?.files ?? [],
            nextPageToken: result.data?.nextPageToken ?? null,
            pageToken: arg.params.params?.page_token ?? null
          }
        };
      },

      serializeQueryArgs: ({ queryArgs }) => {
        const { page_token, ...stableParams } = queryArgs?.params?.params ?? {};
        return {
          endpointName: 'getGoogleDriveContent',
          params: stableParams
        };
      },

      merge: (currentCache, newData) => {
        if (!newData.pageToken) {
          return newData;
        }

        const existingIds = new Set(currentCache.files.map((f) => f.id));
        const newItems = newData.files.filter((f) => !existingIds.has(f.id));
        currentCache.files.push(...newItems);
        currentCache.nextPageToken = newData.nextPageToken;
      },

      forceRefetch({ currentArg, previousArg }) {
        return (
          currentArg?.params?.params?.page_token !==
          previousArg?.params?.params?.page_token
        );
      }
    })
  };
};
export default googleDriveApi;
